/**
 * МАРКИ ИЗ НАШЕГО СОБСТВЕННОГО КАТАЛОГА — сгенерировано, руками не править.
 * Источник: GET /manufacturers. Генератор: scripts/research/gear_brands_data.py.
 *
 * Зачем (SCRUM-606): в каталоге названия лежат БЕЗ марки («Twin Reverb 65», «KARA», «SB18»), а
 * человек марку пишет. Пока в списке стояли только производители микрофонов, «Shure SM58»
 * сводилось, а «Fender Twin Reverb» — нет, и выглядело это как будто у нас нет бэклайна.
 *
 * Короче 3 знаков сюда не попадает: «KM» снял бы «KMS-105» до «S105».
 */
export const CATALOG_BRANDS = [
    "radialengineering",
    "solidstatelogic",
    "gallienkrueger",
    "audiotechnika",
    "beyerdynamic",
    "electrovoice",
    "funktionone",
    "klarkteknik",
    "martinaudio",
    "allenheath",
    "labgruppen",
    "lacoustics",
    "mesaboogie",
    "meyersound",
    "sennheiser",
    "soundcraft",
    "telefunken",
    "behringer",
    "darkglass",
    "powersoft",
    "digigrid",
    "hercules",
    "markbass",
    "marshall",
    "mccauley",
    "zildjian",
    "adamson",
    "aguilar",
    "gretsch",
    "hammond",
    "neumann",
    "protone",
    "wisycom",
    "digico",
    "fender",
    "kamp;m",
    "leslie",
    "ludwig",
    "noname",
    "orange",
    "paiste",
    "roland",
    "sabian",
    "yamaha",
    "ampeg",
    "audix",
    "aviom",
    "klang",
    "midas",
    "pearl",
    "proel",
    "shure",
    "waves",
    "avid",
    "coda",
    "korg",
    "nexo",
    "nord",
    "rode",
    "tama",
    "akg",
    "bss",
    "dpa",
    "eaw",
    "ebs",
    "jbl",
    "rcf",
    "vox",
];
//# sourceMappingURL=gear-brands.data.js.map